import { useHistory } from 'react-router-dom';

import Skeleton from '@/components/common/Skeleton/Skeleton';
import AccessIcon from '@/assets/img/access-icon.svg?react';
import Page from '@/components/Page/Page';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { browserHistory } from '@/routing/browserHistory';
import styles from './home.module.scss';
import useGetSearchTags from './hooks/useGetSearchTags';
import SearchTagsContainer from './components/SearchTags.container';
import Tile from '@/components/common/Tile/Tile';
import { PageForms } from '@/config/pageForms.config';
import useGetSavedSearches from './hooks/useGetRecentSavedSearches';
import { Search } from '@/graphql/contracts/_generated_/contracts';
import SearchContractsContainer from './components/SearchContract.container.container';
import { contractsBCPath } from '@/utils/path.utlis';

export default function Home() {
  const history = useHistory();
  const { searchTags, isLoadingTags } = useGetSearchTags();
  const { recentSavedSearches, isLoadingSavedSearches } = useGetSavedSearches();

  const handleChangeCustomerID = (customerName: string | null) => {
    if (customerName) {
      browserHistory.push(getParameterizedLink(`/${contractsBCPath}?search=${encodeURIComponent(customerName)}`));
    }
  };

  const handleSavedFilterRedirect = (search: Search) => {
    const redirectLink = `${PageForms[search.form!]}/filteredBy?filterKey=${search.rowKey}&filterName=${search.title}`;
    history.push(getParameterizedLink(redirectLink));
  };

  return (
    <Page
      style={{ background: '#fff' }}
      pageTitle="Home Page"
    >
      <div className={styles.homePage}>
        <div className={styles.accessLogo}>
          <div className={styles.accessIcon}>
            <AccessIcon />
          </div>
          <span className={styles.accessName}>access</span>
          <span className={styles.productName}>Contracts And Billing</span>
        </div>

        <div className={styles.search}>
          <SearchContractsContainer handleChangeCustomerID={handleChangeCustomerID} />
        </div>

        <div className={styles.tags}>
          {isLoadingTags && !searchTags.length && Array(6).fill('').map((_, i) => (
            <Skeleton key={i} width={100} height={26} borderRadius={500} />
          ))}

          {!isLoadingTags && !searchTags.length && (
            <span className={styles['no-search-tags']}>No search tags saved, start searching...</span>
          )}

          {searchTags.length > 0 && <SearchTagsContainer searchTags={searchTags} />}

        </div>
        <div className={styles.tiles}>
          {isLoadingSavedSearches && !recentSavedSearches.length && Array(9).fill('').map((_, i) => (
            <Skeleton key={i} width={160} height={147} borderRadius={4} />
          ))}
          {!isLoadingSavedSearches && !recentSavedSearches.length && (
            <span className={styles['no-search-tags']}>No recent saved filters...</span>
          )}

          {recentSavedSearches?.length > 0 && (
            recentSavedSearches.map((search: Search) => (
              <Tile key={search.rowKey}
                searchPage={search.form!}
                title={search.title!}
                onClick={() => handleSavedFilterRedirect(search)} />
            )))
          }
        </div>

      </div>
    </Page>
  );
}
